<template>
<div class="viskase-feature-tile container">
    <div class="viskase-feature-tile-content row justify-content-start align-items-center" v-if="variant === 'image-left'">
        <div class="text-start col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
            <img :src="img" class="card-img-left img-responsive" style="width: 100%;" />
        </div>
        <div class="text-start col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
            <div><span class="fw-bold h4">{{title}}</span></div>
            <div><span class=" ">{{desc}}</span></div>
            <div v-if="attributes.length">
                <ul>
                    <li v-for="att in attributes" :key="att.id">{{att.desc}}</li>
                </ul>
            </div>
        </div>
    </div>
    <div class="viskase-feature-tile-content row justify-content-start align-items-center d-flex" v-if="variant === 'image-right'">
        <div class="text-start col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 order-xs-2 order-2 order-md-1 ">
            <div><span class="fw-bold h4">{{title}}</span></div>
            <div><span class=" ">{{desc}}</span></div>
            <div v-if="attributes.length">
                <ul>
                    <li v-for="att in attributes" :key="att.id">{{att.desc}}</li>
                </ul>
            </div>
        </div>
        <div class="text-start col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 order-xs-1 order-1 order-md-2">
            <img :src="img" class="card-img-right img-responsive" style="width: 100%;" />
        </div>
    </div>
    <div class="viskase-feature-tile-content row justify-content-start align-items-center" v-if="variant === 'image-top'">
        <div class="col-12">
            <img :src="img" class="card-img-top img-responsive" style="width: 100%;" />
        </div>
        <div class="col-12">
            <div><span class="fw-bold h4">{{title}}</span></div>
            <div><span class=" ">{{desc}}</span></div>
            <div v-if="attributes.length">
                <ul>
                    <li v-for="att in attributes" :key="att.id">{{att.desc}}</li>
                </ul>
            </div>
        </div>
    </div>
    <div class="viskase-feature-tile-content row justify-content-start align-items-center" v-if="variant === 'image-bottom'">
        <div class="col-12">
            <div><span class="fw-bold h4">{{title}}</span></div>
            <div><span class=" ">{{desc}}</span></div>
            <div v-if="attributes.length">
                <ul>
                    <li v-for="att in attributes" :key="att.id">{{att.desc}}</li>
                </ul>
            </div>
        </div>
        <div class="col-12">
            <img :src="img" class="card-img-bottom img-responsive" style="width: 100%;" />
        </div>
    </div>
</div>
</template>

<script>
export default {
  name: "ViskaseFeatureTile",
  props: {
    variant: {
      type: String,
      default: "image-right",
    },
    img: {
      type: String,
      default: "",
    },
    desc: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    attributes: {
      type: Array,
      default: [],
    },
  },
};
</script>

<style lang="scss" scoped>
.viskase-feature-tile {
  min-height: 60px;
  border: 0px solid #a0273b;
  padding: 3px;
}

.ul {
  list-style-type: circle;
}
</style>
